const memberTranslations = {
  fi: {
    common: {
      cancel: 'Peruuta',
      save: 'Tallenna',
      loading: 'Ladataan...',
      required: 'Pakollinen',
      requiredField: 'Pakollinen kenttä',
      error: 'Virhe',
      connectionError: 'Yhteysvirhe. Kokeile uudelleen.',
      saveFailed: 'Tallennus epäonnistui',
      saveError: 'Virhe tallennuksessa',
      uploadFailed: 'Kuvan lataus epäonnistui',
      select: 'Valitse...',
      edit: 'Muokkaa',
      delete: 'Poista',
      add: 'Lisää',
      close: 'Sulje',
      retry: 'Yritä uudelleen',
      rules: 'Säännöt',
      video: 'Video',
      players: 'pelaajaa',
      player: 'Pelaaja',
      rank: 'Sija',
      points: 'Pisteet',
      date: 'Päivä',
      duration: 'Kesto',
      results: 'Tulokset',
      season: 'Kausi',
      games: 'peliä',
      hours: 'h',
      minutes: 'min',
      hoursLabel: 'Tunnit',
      minutesLabel: 'Minuutit',
      noData: 'Ei tietoja',
      confirmDelete: 'Haluatko varmasti poistaa?',
      optional: 'valinnainen',
      allSeasonsHint: 'Tyhjä valinta = kaikki kaudet',
      allGamesHint: 'Tyhjä valinta = kaikki pelit',
      clear: 'Tyhjennä',
      noVotes: 'Ei ääniä',
      creating: 'Luodaan...',
      upload: 'Lataa',
      url: 'URL',
      clickToOpen: 'Klikkaa avataksesi',
      leaguePoints: 'MP',
      victoryPoints: 'VP',
      victoryPointsTitle: 'Pelin sisäiset pisteet',
      leaguePointsTitle: 'Menestyspisteet (lasketaan automaattisesti)',
      leaguePointsRankTitle: 'Sarjapisteet sijoituksen perusteella'
    },
    skillLevels: {
      beginner: 'Aloittelija',
      beginnerDesc: 'Ensimmäinen pelaus',
      novice: 'Noviisi',
      noviceDesc: 'Muutama pelaus taustalla',
      hobbyist: 'Harrastaja',
      hobbyistDesc: 'Perussäännöt hallussa',
      experienced: 'Kokenut',
      experiencedDesc: 'Strategiat tuttuja',
      veteran: 'Veteraani',
      veteranDesc: 'Edistyneet taktiikat',
      pro: 'Pro',
      proDesc: 'Mestarin taso'
    },
    gameVariants: {
      standard: 'Peruspeli',
      standardDesc: 'Viralliset säännöt',
      quick: 'Nopea peli',
      quickDesc: 'Lyhennetty versio',
      extended: 'Pitkä peli',
      extendedDesc: 'Laajennetut säännöt'
    },
    gamesLibrary: {
      title: 'Pelikirjasto',
      addGame: '+ Lisää Peli',
      prevGame: 'Edellinen peli',
      nextGame: 'Seuraava peli',
      downloadRules: 'Lataa säännöt (PDF)',
      watchVideo: 'Katso opastusvideo',
      bggPage: 'BoardGameGeek-sivu',
      gameSetup: 'Pelin Setup',
      gameSetupTitle: 'Näytä pelin setup-ohje',
      askHelp: 'Kysy Apua',
      askRulesTitle: 'Kysy säännöistä',
      history: 'Pelihistoria',
      noSessions: 'Ei pelattuja sessioita',
      seasonHeader: 'Kausi {season} ({count} peliä)',
      setupFailed: 'Setup-ohjeen luominen epäonnistui',
      errorPrefix: 'Virhe: {message}'
    },
    gameForm: {
      editTitle: 'Muokkaa Peliä',
      addTitle: 'Lisää Uusi Peli',
      aiFound: '✨ AI löysi tiedot!',
      aiFoundDesc: 'Kentät täytetty automaattisesti.',
      geminiInfo: 'Gemini AI tiedot:',
      nameLabel: 'Pelin Nimi *',
      namePlaceholder: 'esim. Catan',
      aiHint: '🤖 AI hakee automaattisesti pelin tiedot kun kirjoitat nimen',
      bggIdLabel: 'BoardGameGeek ID',
      bggIdPlaceholder: 'esim. 13',
      bggIdHint: 'Löytyy BGG URL:sta (boardgamegeek.com/boardgame/13/catan)',
      boxImage: 'Laatikkokuva',
      setupImage: 'Setup-kuva',
      imagesLabel: 'Pelin Kuvat',
      boxImageHint: '📦 Laatikkokuva näkyy pelilistoissa ja hakutuloksissa',
      setupImageHint: '🎮 Setup-kuva näkyy pelin setup-ohjeissa taustakuvana',
      imageUrlPlaceholder: 'https://... tai /game-images/...',
      saveImageToServer: 'Tallenna kuva palvelimelle',
      searchFor: 'Hae: "{query}"',
      clickToUpload: 'Klikkaa ladataksesi',
      removeBoxImage: 'Poista laatikkokuva',
      removeSetupImage: 'Poista setup-kuva',
      bggLinkLabel: 'BGG Linkki',
      bggLinkPlaceholder: 'https://boardgamegeek.com/...',
      bggLinkHint: 'BoardGameGeek-sivun linkki',
      rulesPdfLabel: 'Säännöt (PDF)',
      rulesPdfPlaceholder: 'https://...rules.pdf',
      rulesPdfHint: 'Linkki PDF-sääntökirjaan',
      videoLabel: 'Opastusvideo',
      videoPlaceholder: 'https://youtube.com/watch?v=...',
      videoHint: 'YouTube-video pelin opettelua varten',
      expansions: 'Lisäosat ({count})',
      confirmDeleteExpansion: 'Poistetaanko lisäosa?',
      expansionName: 'Lisäosan nimi',
      expansionNamePlaceholder: 'esim. Seafarers',
      owned: 'Omistamme',
      notOwned: 'Ei omisteta',
      fetchingExpansions: 'Haetaan lisäosia BGG:stä ja AI:lta...',
      foundExpansions: 'Löydetyt lisäosat ({source})',
      noExpansionsFound: 'Ei lisäosia löytynyt',
      iOwn: 'Omistan',
      expansionNameRequired: 'Lisäosan nimi *'
    },
    sessionForm: {
      editTitle: 'Muokkaa Sessiota',
      addTitle: 'Kirjaa Peli (Session)',
      gameLabel: 'Peli',
      selectGame: 'Valitse peli...',
      dateLabel: 'Päivämäärä',
      resultsLabel: 'Tulokset',
      editResultsHint: 'Muokkaa sijoituksia ja pisteitä. Menestyspisteet lasketaan automaattisesti sijoituksen perusteella.',
      addResultsHint: 'Lisää pelaajat sijoitusjärjestyksessä.',
      scorePlaceholder: 'esim. 145',
      addPlayer: 'Lisää pelaaja',
      expansionsUsed: 'Käytetyt lisäosat',
      loadingExpansions: 'Ladataan lisäosia...',
      expansionsHint: 'Valitse pelisessiossa käytetyt lisäosat',
      imageLabel: 'Kuva (Selfie / Lauta)',
      changeImage: 'Vaihda kuva',
      takeOrSelectImage: 'Ota kuva tai valitse tiedosto',
      saveChanges: 'Tallenna Muutokset',
      saveSession: 'Tallenna Session',
      uploadFailedContinue: 'Kuvan lataus epäonnistui, tallennetaan ilman kuvaa.'
    },
    setupDialog: {
      title: 'Pelin Setup',
      unknownGame: 'Tuntematon peli',
      playerCount: 'Pelaajamäärä',
      playerRange: '{game} tukee {min}-{max} pelaajaa',
      skillLevel: 'Osaamistaso',
      gameMode: 'Pelimuoto',
      showSetup: 'Näytä Setup'
    },
    gameSetupOverlay: {
      setupTitle: 'Setup',
      gameBoard: '{name} pelilauta',
      generating: 'Generoidaan setup-ohjetta...',
      analyzingRules: 'AI analysoi pelin "{name}" säännöt',
      errorTitle: 'Virhe setup-ohjeen luomisessa',
      preparation: '📋 Pelin valmistelu',
      turnStructure: '🔄 Pelikierroksen kulku',
      selectTarget: 'Valitse kohde',
      noDescription: 'Ei kuvausta saatavilla.',
      steps: 'Vaiheet:',
      clickHint: '👆 Klikkaa korostettua aluetta nähdäksesi ohjeet',
      allParts: 'Kaikki osat:'
    },
    gameHelpChat: {
      title: 'Sääntöapu',
      gameFallback: 'Peli',
      rulesPdf: 'Säännöt (PDF)',
      assistant: 'Sääntöavustaja',
      confidenceHigh: '✓ Varma',
      confidenceMedium: '~ Todennäköinen',
      confidenceLow: '? Epävarma',
      sources: '📚 Lähteet:',
      checkingRules: 'Tarkistan säännöistä...',
      quickQuestions: 'Pikakyselyt:',
      placeholder: 'Kysy säännöistä...',
      disclaimer: '⚠️ Vastaukset perustuvat virallisiin sääntöihin. Tarkista epäselvissä tilanteissa alkuperäiset säännöt.',
      welcomeIntro: 'Tervetuloa {name} -sääntöavustajaan! 📖\n\nVoin auttaa sinua pelin säännöissä. Vastaan VAIN virallisten sääntöjen mukaan - en arvaa tai tulkitse.',
      welcomeExpansions: '\n\n📦 Omistamanne lisäosat: {list}\nVoin vastata myös näiden lisäosien säännöistä!',
      welcomeExamples: '\n\nKysy esimerkiksi:\n• "Miten vuoro etenee?"\n• "Mitä tapahtuu tasatilanteessa?"\n• "Kuinka pisteet lasketaan?"',
      noAnswer: 'Pahoittelut, en pystynyt vastaamaan kysymykseen.',
      quickSetup: 'Miten peli valmistellaan?',
      quickTurn: 'Miten vuoro etenee?',
      quickEnd: 'Miten peli päättyy?',
      quickScoring: 'Miten pisteet lasketaan?'
    },
    sessionDetail: {
      resultsTitle: 'Tulokset'
    },
    eventScheduler: {
      title: 'Peli-illat',
      loading: 'Ladataan tapahtumia...',
      featureDisabled: 'Tämä toiminto ei ole aktivoitu tälle klubille. SuperAdmin voi ottaa sen käyttöön klubin beta-toiminnoista.',
      suggestEvent: 'Ehdota peli-iltaa',
      noUpcoming: 'Ei tulevia peli-iltoja',
      suggestFirst: 'Ehdota ensimmäinen!',
      attendees: '{count} osallistujaa',
      atTime: 'klo',
      durationApprox: 'Kesto: ~{hours} tuntia',
      attendingQuestion: 'Osallistutko?',
      attending: 'Osallistun',
      maybe: 'Ehkä',
      notAttending: 'En pääse',
      registrations: 'Ilmoittautumiset',
      addPlayer: 'Lisää',
      selectPlayer: 'Valitse pelaaja...',
      attendingList: 'Osallistuvat ({count})',
      maybeList: 'Ehkä ({count})',
      declinedList: 'Eivät pääse ({count})',
      noRegistrations: 'Ei vielä ilmoittautumisia',
      markAttending: 'Merkitse osallistujaksi',
      deleteEvent: 'Poista peli-ilta',
      confirmDeleteEvent: 'Haluatko varmasti poistaa tämän peli-illan?',
      createTitle: 'Ehdota peli-iltaa',
      titleLabel: 'Otsikko *',
      titlePlaceholder: 'esim. Torstai-illan pelit',
      scheduleLabel: 'Ajankohta *',
      dateLabel: 'Päivämäärä',
      timeLabel: 'Kellonaika',
      estimatedDuration: 'Arvioitu kesto',
      hour: '{n} tunti',
      hours: '{n} tuntia',
      descriptionLabel: 'Kuvaus',
      descriptionPlaceholder: 'Mitä pelataan? Erityistä huomioitavaa?',
      gameOptional: 'Peli (valinnainen)',
      selectLater: '-- Valitse myöhemmin --',
      location: 'Paikka',
      addNewLocation: 'Lisää uusi',
      locationName: 'Paikan nimi *',
      locationNamePlaceholder: 'esim. Matin koti',
      addressOptional: 'Osoite (valinnainen)',
      addressPlaceholder: 'esim. Esimerkkikatu 1, Helsinki',
      createLocation: 'Luo paikka',
      noLocationSelected: '-- Ei valittu --',
      noSavedLocations: 'Ei tallennettuja paikkoja. Luo uusi paikka ylhäältä.',
      suggestedLocation: '✨ Ehdotettu edellisen peli-illan perusteella',
      minPlayers: 'Min pelaajia',
      maxPlayers: 'Max pelaajia',
      visibilityHint: '📢 Kaikki klubin jäsenet näkevät tapahtuman ja voivat ilmoittautua.',
      createEvent: 'Luo peli-ilta',
      titleRequired: 'Anna peli-illalle otsikko',
      dateTimeRequired: 'Päivämäärä ja kellonaika ovat pakollisia',
      createFailed: 'Tapahtuman luonti epäonnistui',
      locationCreateFailed: 'Paikan luonti epäonnistui'
    },
    suggestionBox: {
      title: '🗳️ Kehityslaatikko',
      subtitle: 'Ideat jakoon! Ehdota, äänestä ja kommentoi.',
      privateMode: 'Yksityinen tila: ehdotuksesi näkyvät vain sinulle ja adminille.',
      tabOpen: 'Avoimet',
      tabImplemented: 'Toteutetut',
      tabRejected: 'Hylätyt',
      statusOpen: 'Avoin',
      statusImplemented: 'Toteutettu',
      statusRejected: 'Hylätty',
      suggestNew: 'Ehdota uutta',
      newSuggestion: 'Uusi ehdotus',
      titleLabel: 'Otsikko *',
      titlePlaceholder: 'Esim. Ostetaan Catan',
      descriptionLabel: 'Kuvaus',
      descriptionPlaceholder: 'Kerro tarkemmin ideasta...',
      submit: 'Lähetä ehdotus',
      noSuggestions: 'Ei vielä ehdotuksia. Ole ensimmäinen!',
      comments: 'Kommentit ({count})',
      comment: 'Kommentoi',
      markImplemented: 'Toteutettu',
      markRejected: 'Hylätty',
      show: 'Näytä',
      hide: 'Piilota',
      hiddenFromUsers: 'Piilotettu muilta käyttäjiltä',
      commentsTitle: 'Kommentit',
      noComments: 'Ei kommentteja vielä.',
      addComment: 'Lisää kommentti...',
      confirmDelete: 'Haluatko varmasti poistaa tämän ehdotuksen?'
    },
    statistics: {
      title: 'Pelitilastot',
      loading: 'Ladataan tilastoja...',
      refreshing: 'Päivitetään tilastoja...',
      errorPrefix: 'Virhe: {message}',
      filterTitle: 'Suodata analyysit',
      seasons: 'Kaudet',
      games: 'Pelit',
      proOnly: 'Pro',
      proRequired: 'Vanhojen kausien tilastot vaativat Pro-tason.',
      currentSeasonOnly: 'Free-tasolla näet kuluvan kauden.',
      archivedProOnly: 'Vanhat kaudet säilyvät tallessa ja avautuvat Pro-tasolla.',
      comparePlans: 'Katso tasot',
      totalSessions: 'Pelisessiota',
      uniqueGames: 'Eri peliä',
      totalPlayers: 'Pelaajaa',
      totalTime: 'Kokonaisaika',
      zeroMin: '0 min'
    },
    statisticsAnalytics: {
      loadingSessions: 'Ladataan sessioita...',
      noSessionData: 'Ei sessiotietoja',
      clickGameHint: 'Klikkaa peliä nähdäksesi tiedot.',
      longestGames: 'Pisimmät pelit',
      longestGamesSub: 'Eniten aikaa käytetty',
      mostPlayed: 'Suosituimmat pelit',
      mostPlayedSub: 'Eniten pelattuja',
      winRates: 'Voittoprosentit',
      winRatesSub: 'Vähintään 3 peliä',
      winStreaks: 'Voittoputket',
      winStreaksSub: 'Peräkkäiset voitot',
      winStreakCount: '{count} voittoa peräkkäin',
      highestScores: 'Korkeimmat pisteet',
      highestScoresSub: 'Top 10 suoritukset',
      closestGames: 'Tasaisimmat pelit',
      closestGamesSub: 'Pienin ero voittajan ja kakkosen välillä',
      playerFavorites: 'Pelaajien suosikit',
      playerFavoritesSub: 'Eniten pelattu peli per pelaaja',
      playedWins: '{played}x pelattu • {wins} voittoa',
      monthlyActivity: 'Kuukausiaktiivisuus',
      monthlyActivitySub: 'Pelaamisen trendi',
      sessionsTooltip: '{count} sessiota',
      avgLeaguePoints: 'Keskimääräinen menestyspisteansio',
      avgLeaguePointsSub: 'Johtotaulukko per pelattu peli',
      leaguePointsTitle: 'Menestyspisteet',
      leaguePointsSub: 'Yhteispisteet valituilla kausilla ja peleillä. Klikkaa pelaajaa nähdäksesi pelit.',
      medalPercentage: 'Mitalisijoitus-%',
      medalPercentageSub: 'Sijoitus 1., 2. tai 3. kaikista peleistä. Klikkaa pelaajaa nähdäksesi mitalipelit.',
      medalTable: 'Mitalitaulukko',
      medalTableSub: 'Olympiajärjestys: kulta, hopea, pronssi. Klikkaa pelaajaa nähdäksesi mitalipelit.',
      headToHead: 'Keskinäiset kohtaamiset',
      headToHeadSub: 'Kuka voittaa ketä useimmin',
      colGame: 'Peli',
      colTotal: 'Yhteensä',
      colCount: 'Kerrat',
      colAverage: 'Keskiarvo',
      colPlayed: 'Pelattu',
      colPlayers: 'Pelaajia',
      colWinPct: 'Voitto-%',
      colWins: 'Voitot',
      colGames: 'Pelejä',
      colAvgRank: 'Kesk.sij.',
      colScore: 'Pisteet',
      colDate: 'Pvm',
      colMedalPct: 'Mitali-%',
      colMedals: 'Mitalit',
      colTotalShort: 'Yht.',
      vs: 'vs',
      socialNemesis: 'Nemesis',
      socialNemesisSub: 'Kuka sijoittuu sinua ylemmäs useimmin (≥3 kohtaamista). Klikkaa pelaajaa nähdäksesi sessiot.',
      socialKingmaker: 'Kingmaker',
      socialKingmakerSub: 'Tiukkojen pelien kakkossijat (raw_score, ≥5 sessiota)',
      socialCloser: 'Closer',
      socialCloserSub: 'Voitot tiukoissa peleissä (raw_score)',
      socialChoker: 'Choker',
      socialChokerSub: 'Tiukat lähellä voittoa jääneet top-3-sijoitukset',
      socialGiantSlayer: 'Giant Slayer',
      socialGiantSlayerSub: 'Voitot sessioissa, joissa on #1 (menestyspisteet)',
      socialSpecialist: 'Specialist',
      socialSpecialistSub: 'Peli, jossa voittoprosentti on korkein (≥3 sessiota)',
      socialRivalry: 'Rivalry',
      socialRivalrySub: 'Kohtaamisten intensiteetti (≥3 yhteistä sessiota)',
      socialSkill: 'Skill-rating',
      socialSkillSub: 'OpenSkill-luku (ei korvaa menestyspisteitä)',
      socialEvidenceGames: 'Laskennassa käytetyt pelit'
    },
    chatInterface: {
      fabTitle: 'The Oracle - AI Assistant',
      title: 'The Oracle',
      shrink: 'Pienennä',
      fullscreen: 'Koko ruutu',
      oracle: 'oracle',
      cached: '⚡ cached',
      chartTitle: 'Tilasto',
      autoRetry: 'Yritetään automaattisesti uudelleen:',
      analyzing: 'Analysoidaan...',
      placeholder: 'Kysy oraakkelilta...',
      connectionError: 'Yhteysvirhe oraakkeliin. Kokeile uudelleen. 🌩️',
      welcome: 'Tervetuloa Oraakkelin puheille! 🔮\n\nVoit kysyä minulta:\n• Klubin tilastoja\n• Pelisääntöjä\n• Kuka on paras pelaaja?\n\nKirjoita kysymyksesi alle...',
      chartValue: 'Arvo'
    },
    nextGamePrediction: {
      analyzing: 'Analysoidaan todennäköisyysmatriisia...',
      predicted: '🔮 Tuleva pelipäivä: {count} peliä ennustettu',
      askOracle: '🔮 Kysy Oraakkelilta tuleva pelipäivä',
      newPrediction: 'Uusi ennustus',
      failed: 'Ennustus epäonnistui',
      title: 'Oraakkelin ennustus',
      upcomingGameDay: 'Tuleva pelipäivä',
      rationale: '💭 Perustelu:',
      poweredByGemini: 'Gemini AI',
      poweredBySkill: 'Skill rating'
    },
    sessionWrap: {
      title: 'Pelin kooste',
      winner: 'Voittaja',
      photoFinish: 'Photo finish (tiukka raw_score)',
      copy: 'Kopioi teksti',
      copied: 'Kopioitu'
    },
    smartRecommendations: {
      recommendation: 'Suositus',
      forYou: 'Suositukset sinulle',
      view: 'Katso',
      gameSpecific: '🎯 Tälle pelille',
      categoryMatch: '📂 Sinun tyylisi',
      recentlyViewed: '👁️ Katsomasi peli',
      featured: '⭐ Suositeltu',
      aiSuggestion: '🤖 Tekoälyn suositus',
      default: '💡 Suositus'
    },
    terminalGame: {
      startFailed: 'Pelin käynnistys epäonnistui: {message}',
      sessionExpired: 'Pelisessio on vanhentunut. Peli on tallennettu automaattisesti.',
      errorPrefix: '[Virhe: {message}]',
      sessionRestored: '--- Pelisessio palautettu muistista ---\nKirjoita "look" nähdäksesi missä olet.',
      saved: 'Tallennettu!',
      saveGame: 'Tallenna peli',
      restartTitle: 'Aloita alusta (poistaa tallennuksen)',
      closeAndSave: 'Sulje ja tallenna (ESC)',
      startNew: 'Aloita uusi peli',
      thinking: 'Thinking...',
      wait: 'Odota...',
      commandPlaceholder: 'Kirjoita komento...',
      turn: 'Vuoro: {count}',
      historySaved: 'Historia tallennettu. Peli jatkuu automaattisesti niin kauan kuin sessio on aktiivinen (30 min).',
      loginToSave: 'Kirjaudu sisään tallentaaksesi pelin historian.'
    },
    setupComponents: {
      cardDeck: 'Korttipakka',
      cube: 'Kuutio',
      disc: 'Levy',
      token: 'Token',
      resource: 'Resurssi',
      player: 'Pelaaja {number}',
      points: 'Pisteet',
      diceCount: '{count} noppaa'
    }
  },
  en: {
    common: {
      cancel: 'Cancel',
      save: 'Save',
      loading: 'Loading...',
      required: 'Required',
      requiredField: 'Required field',
      error: 'Error',
      connectionError: 'Connection error. Please try again.',
      saveFailed: 'Save failed',
      saveError: 'Error while saving',
      uploadFailed: 'Image upload failed',
      select: 'Select...',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      close: 'Close',
      retry: 'Try again',
      rules: 'Rules',
      video: 'Video',
      players: 'players',
      player: 'Player',
      rank: 'Rank',
      points: 'Points',
      date: 'Date',
      duration: 'Duration',
      results: 'Results',
      season: 'Season',
      games: 'games',
      hours: 'h',
      minutes: 'min',
      hoursLabel: 'Hours',
      minutesLabel: 'Minutes',
      noData: 'No data',
      confirmDelete: 'Are you sure you want to delete?',
      optional: 'optional',
      allSeasonsHint: 'Empty selection = all seasons',
      allGamesHint: 'Empty selection = all games',
      clear: 'Clear',
      noVotes: 'No votes',
      creating: 'Creating...',
      upload: 'Upload',
      url: 'URL',
      clickToOpen: 'Click to open',
      leaguePoints: 'LP',
      victoryPoints: 'VP',
      victoryPointsTitle: 'In-game points',
      leaguePointsTitle: 'League points (calculated automatically)',
      leaguePointsRankTitle: 'League points based on placement'
    },
    skillLevels: {
      beginner: 'Beginner',
      beginnerDesc: 'First time playing',
      novice: 'Novice',
      noviceDesc: 'A few games played',
      hobbyist: 'Hobbyist',
      hobbyistDesc: 'Knows the basic rules',
      experienced: 'Experienced',
      experiencedDesc: 'Familiar with strategies',
      veteran: 'Veteran',
      veteranDesc: 'Advanced tactics',
      pro: 'Pro',
      proDesc: 'Master level'
    },
    gameVariants: {
      standard: 'Standard game',
      standardDesc: 'Official rules',
      quick: 'Quick game',
      quickDesc: 'Shortened version',
      extended: 'Long game',
      extendedDesc: 'Extended rules'
    },
    gamesLibrary: {
      title: 'Game library',
      addGame: '+ Add game',
      prevGame: 'Previous game',
      nextGame: 'Next game',
      downloadRules: 'Download rules (PDF)',
      watchVideo: 'Watch tutorial video',
      bggPage: 'BoardGameGeek page',
      gameSetup: 'Game setup',
      gameSetupTitle: 'Show game setup guide',
      askHelp: 'Ask for help',
      askRulesTitle: 'Ask about rules',
      history: 'Play history',
      noSessions: 'No sessions played',
      seasonHeader: 'Season {season} ({count} games)',
      setupFailed: 'Failed to create setup guide',
      errorPrefix: 'Error: {message}'
    },
    gameForm: {
      editTitle: 'Edit game',
      addTitle: 'Add new game',
      aiFound: '✨ AI found details!',
      aiFoundDesc: 'Fields filled automatically.',
      geminiInfo: 'Gemini AI details:',
      nameLabel: 'Game name *',
      namePlaceholder: 'e.g. Catan',
      aiHint: '🤖 AI automatically fetches game details as you type the name',
      bggIdLabel: 'BoardGameGeek ID',
      bggIdPlaceholder: 'e.g. 13',
      bggIdHint: 'Found in the BGG URL (boardgamegeek.com/boardgame/13/catan)',
      boxImage: 'Box image',
      setupImage: 'Setup image',
      imagesLabel: 'Game images',
      boxImageHint: '📦 Box image appears in game lists and search results',
      setupImageHint: '🎮 Setup image appears as background in setup instructions',
      imageUrlPlaceholder: 'https://... or /game-images/...',
      saveImageToServer: 'Save image to server',
      searchFor: 'Search: "{query}"',
      clickToUpload: 'Click to upload',
      removeBoxImage: 'Remove box image',
      removeSetupImage: 'Remove setup image',
      bggLinkLabel: 'BGG link',
      bggLinkPlaceholder: 'https://boardgamegeek.com/...',
      bggLinkHint: 'Link to BoardGameGeek page',
      rulesPdfLabel: 'Rules (PDF)',
      rulesPdfPlaceholder: 'https://...rules.pdf',
      rulesPdfHint: 'Link to PDF rulebook',
      videoLabel: 'Tutorial video',
      videoPlaceholder: 'https://youtube.com/watch?v=...',
      videoHint: 'YouTube video for learning the game',
      expansions: 'Expansions ({count})',
      confirmDeleteExpansion: 'Delete this expansion?',
      expansionName: 'Expansion name',
      expansionNamePlaceholder: 'e.g. Seafarers',
      owned: 'We own',
      notOwned: 'Not owned',
      fetchingExpansions: 'Fetching expansions from BGG and AI...',
      foundExpansions: 'Found expansions ({source})',
      noExpansionsFound: 'No expansions found',
      iOwn: 'I own',
      expansionNameRequired: 'Expansion name *'
    },
    sessionForm: {
      editTitle: 'Edit session',
      addTitle: 'Log game (session)',
      gameLabel: 'Game',
      selectGame: 'Select game...',
      dateLabel: 'Date',
      resultsLabel: 'Results',
      editResultsHint: 'Edit placements and scores. League points are calculated automatically from placement.',
      addResultsHint: 'Add players in placement order.',
      scorePlaceholder: 'e.g. 145',
      addPlayer: 'Add player',
      expansionsUsed: 'Expansions used',
      loadingExpansions: 'Loading expansions...',
      expansionsHint: 'Select expansions used in this session',
      imageLabel: 'Photo (selfie / board)',
      changeImage: 'Change image',
      takeOrSelectImage: 'Take a photo or choose a file',
      saveChanges: 'Save changes',
      saveSession: 'Save session',
      uploadFailedContinue: 'Image upload failed, saving without image.'
    },
    setupDialog: {
      title: 'Game setup',
      unknownGame: 'Unknown game',
      playerCount: 'Number of players',
      playerRange: '{game} supports {min}-{max} players',
      skillLevel: 'Skill level',
      gameMode: 'Game mode',
      showSetup: 'Show setup'
    },
    gameSetupOverlay: {
      setupTitle: 'Setup',
      gameBoard: '{name} game board',
      generating: 'Generating setup guide...',
      analyzingRules: 'AI is analysing the rules for "{name}"',
      errorTitle: 'Error creating setup guide',
      preparation: '📋 Game preparation',
      turnStructure: '🔄 Turn structure',
      selectTarget: 'Select a target',
      noDescription: 'No description available.',
      steps: 'Steps:',
      clickHint: '👆 Click a highlighted area to see instructions',
      allParts: 'All parts:'
    },
    gameHelpChat: {
      title: 'Rules help',
      gameFallback: 'Game',
      rulesPdf: 'Rules (PDF)',
      assistant: 'Rules assistant',
      confidenceHigh: '✓ Confident',
      confidenceMedium: '~ Likely',
      confidenceLow: '? Uncertain',
      sources: '📚 Sources:',
      checkingRules: 'Checking the rules...',
      quickQuestions: 'Quick questions:',
      placeholder: 'Ask about rules...',
      disclaimer: '⚠️ Answers are based on official rules. Check the original rules in unclear situations.',
      welcomeIntro: 'Welcome to the {name} rules assistant! 📖\n\nI can help with game rules. I answer ONLY based on official rules — I do not guess or interpret.',
      welcomeExpansions: '\n\n📦 Expansions you own: {list}\nI can also answer questions about these expansions!',
      welcomeExamples: '\n\nTry asking:\n• "How does a turn work?"\n• "What happens in a tie?"\n• "How are points scored?"',
      noAnswer: 'Sorry, I could not answer that question.',
      quickSetup: 'How do you set up the game?',
      quickTurn: 'How does a turn work?',
      quickEnd: 'How does the game end?',
      quickScoring: 'How are points scored?'
    },
    sessionDetail: {
      resultsTitle: 'Results'
    },
    eventScheduler: {
      title: 'Game nights',
      loading: 'Loading events...',
      featureDisabled: 'This feature is not enabled for this club. A SuperAdmin can enable it in the club beta features.',
      suggestEvent: 'Suggest a game night',
      noUpcoming: 'No upcoming game nights',
      suggestFirst: 'Suggest the first one!',
      attendees: '{count} attendees',
      atTime: 'at',
      durationApprox: 'Duration: ~{hours} hours',
      attendingQuestion: 'Will you attend?',
      attending: 'Attending',
      maybe: 'Maybe',
      notAttending: "Can't make it",
      registrations: 'Registrations',
      addPlayer: 'Add',
      selectPlayer: 'Select player...',
      attendingList: 'Attending ({count})',
      maybeList: 'Maybe ({count})',
      declinedList: "Can't attend ({count})",
      noRegistrations: 'No registrations yet',
      markAttending: 'Mark as attending',
      deleteEvent: 'Delete game night',
      confirmDeleteEvent: 'Are you sure you want to delete this game night?',
      createTitle: 'Suggest a game night',
      titleLabel: 'Title *',
      titlePlaceholder: 'e.g. Thursday game night',
      scheduleLabel: 'Schedule *',
      dateLabel: 'Date',
      timeLabel: 'Time',
      estimatedDuration: 'Estimated duration',
      hour: '{n} hour',
      hours: '{n} hours',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'What will you play? Anything special to note?',
      gameOptional: 'Game (optional)',
      selectLater: '-- Choose later --',
      location: 'Location',
      addNewLocation: 'Add new',
      locationName: 'Location name *',
      locationNamePlaceholder: "e.g. Matt's place",
      addressOptional: 'Address (optional)',
      addressPlaceholder: 'e.g. 1 Example Street, Helsinki',
      createLocation: 'Create location',
      noLocationSelected: '-- Not selected --',
      noSavedLocations: 'No saved locations. Create a new one above.',
      suggestedLocation: '✨ Suggested based on the previous game night',
      minPlayers: 'Min players',
      maxPlayers: 'Max players',
      visibilityHint: '📢 All club members can see the event and register.',
      createEvent: 'Create game night',
      titleRequired: 'Enter a title for the game night',
      dateTimeRequired: 'Date and time are required',
      createFailed: 'Failed to create event',
      locationCreateFailed: 'Failed to create location'
    },
    suggestionBox: {
      title: '🗳️ Suggestion box',
      subtitle: 'Share ideas! Suggest, vote and comment.',
      privateMode: 'Private mode: your suggestions are visible only to you and admins.',
      tabOpen: 'Open',
      tabImplemented: 'Implemented',
      tabRejected: 'Rejected',
      statusOpen: 'Open',
      statusImplemented: 'Implemented',
      statusRejected: 'Rejected',
      suggestNew: 'Suggest something new',
      newSuggestion: 'New suggestion',
      titleLabel: 'Title *',
      titlePlaceholder: 'E.g. Buy Catan',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Tell us more about the idea...',
      submit: 'Submit suggestion',
      noSuggestions: 'No suggestions yet. Be the first!',
      comments: 'Comments ({count})',
      comment: 'Comment',
      markImplemented: 'Implemented',
      markRejected: 'Rejected',
      show: 'Show',
      hide: 'Hide',
      hiddenFromUsers: 'Hidden from other users',
      commentsTitle: 'Comments',
      noComments: 'No comments yet.',
      addComment: 'Add a comment...',
      confirmDelete: 'Are you sure you want to delete this suggestion?'
    },
    statistics: {
      title: 'Game statistics',
      loading: 'Loading statistics...',
      refreshing: 'Refreshing statistics...',
      errorPrefix: 'Error: {message}',
      filterTitle: 'Filter analytics',
      seasons: 'Seasons',
      games: 'Games',
      proOnly: 'Pro',
      proRequired: 'Archived season statistics require the Pro plan.',
      currentSeasonOnly: 'The Free plan includes the current season.',
      archivedProOnly: 'Archived seasons remain stored and become available on Pro.',
      comparePlans: 'Compare plans',
      totalSessions: 'Sessions',
      uniqueGames: 'Unique games',
      totalPlayers: 'Players',
      totalTime: 'Total time',
      zeroMin: '0 min'
    },
    statisticsAnalytics: {
      loadingSessions: 'Loading sessions...',
      noSessionData: 'No session data',
      clickGameHint: 'Click a game to see details.',
      longestGames: 'Longest games',
      longestGamesSub: 'Most time spent',
      mostPlayed: 'Most played games',
      mostPlayedSub: 'Most frequently played',
      winRates: 'Win rates',
      winRatesSub: 'At least 3 games',
      winStreaks: 'Win streaks',
      winStreaksSub: 'Consecutive wins',
      winStreakCount: '{count} wins in a row',
      highestScores: 'Highest scores',
      highestScoresSub: 'Top 10 performances',
      closestGames: 'Closest games',
      closestGamesSub: 'Smallest margin between winner and runner-up',
      playerFavorites: 'Player favourites',
      playerFavoritesSub: 'Most played game per player',
      playedWins: 'Played {played}x • {wins} wins',
      monthlyActivity: 'Monthly activity',
      monthlyActivitySub: 'Play trend',
      sessionsTooltip: '{count} sessions',
      avgLeaguePoints: 'Average league points earned',
      avgLeaguePointsSub: 'Leaderboard per game played',
      leaguePointsTitle: 'League points',
      leaguePointsSub: 'Total points for selected seasons and games. Click a player to see games.',
      medalPercentage: 'Medal placement %',
      medalPercentageSub: '1st, 2nd or 3rd place in all games. Click a player to see medal games.',
      medalTable: 'Medal table',
      medalTableSub: 'Olympic order: gold, silver, bronze. Click a player to see medal games.',
      headToHead: 'Head-to-head',
      headToHeadSub: 'Who beats whom most often',
      colGame: 'Game',
      colTotal: 'Total',
      colCount: 'Times',
      colAverage: 'Average',
      colPlayed: 'Played',
      colPlayers: 'Players',
      colWinPct: 'Win %',
      colWins: 'Wins',
      colGames: 'Games',
      colAvgRank: 'Avg. rank',
      colScore: 'Score',
      colDate: 'Date',
      colMedalPct: 'Medal %',
      colMedals: 'Medals',
      colTotalShort: 'Total',
      vs: 'vs',
      socialNemesis: 'Nemesis',
      socialNemesisSub: 'Who finishes above you most often (≥3 meetings). Click a player to see sessions.',
      socialKingmaker: 'Kingmaker',
      socialKingmakerSub: 'Tight-game runner-up finishes (raw_score, ≥5 sessions)',
      socialCloser: 'Closer',
      socialCloserSub: 'Win rate in tight games (raw_score)',
      socialChoker: 'Choker',
      socialChokerSub: 'Tight near-misses among top-3 finishes',
      socialGiantSlayer: 'Giant Slayer',
      socialGiantSlayerSub: 'Wins in sessions with the #1 (success points)',
      socialSpecialist: 'Specialist',
      socialSpecialistSub: 'Game with the highest win rate (≥3 sessions)',
      socialRivalry: 'Rivalry',
      socialRivalrySub: 'Head-to-head intensity (≥3 shared sessions)',
      socialSkill: 'Skill rating',
      socialSkillSub: 'OpenSkill rating (does not replace success points)',
      socialEvidenceGames: 'Games used in calculation'
    },
    chatInterface: {
      fabTitle: 'The Oracle - AI Assistant',
      title: 'The Oracle',
      shrink: 'Minimize',
      fullscreen: 'Full screen',
      oracle: 'oracle',
      cached: '⚡ cached',
      chartTitle: 'Statistics',
      autoRetry: 'Retrying automatically in:',
      analyzing: 'Analysing...',
      placeholder: 'Ask the Oracle...',
      connectionError: 'Connection error to the Oracle. Please try again. 🌩️',
      welcome: 'Welcome to the Oracle! 🔮\n\nYou can ask me about:\n• Club statistics\n• Game rules\n• Who is the best player?\n\nType your question below...',
      chartValue: 'Value'
    },
    nextGamePrediction: {
      analyzing: 'Analysing probability matrix...',
      predicted: '🔮 Upcoming game day: {count} games predicted',
      askOracle: '🔮 Ask the Oracle about the upcoming game day',
      newPrediction: 'New prediction',
      failed: 'Prediction failed',
      title: "Oracle's prediction",
      upcomingGameDay: 'Upcoming game day',
      rationale: '💭 Rationale:',
      poweredByGemini: 'Gemini AI',
      poweredBySkill: 'Skill rating'
    },
    sessionWrap: {
      title: 'Session wrap',
      winner: 'Winner',
      photoFinish: 'Photo finish (tight raw_score)',
      copy: 'Copy text',
      copied: 'Copied'
    },
    smartRecommendations: {
      recommendation: 'Recommendation',
      forYou: 'Recommendations for you',
      view: 'View',
      gameSpecific: '🎯 For this game',
      categoryMatch: '📂 Your style',
      recentlyViewed: '👁️ Recently viewed',
      featured: '⭐ Featured',
      aiSuggestion: '🤖 AI suggestion',
      default: '💡 Recommendation'
    },
    terminalGame: {
      startFailed: 'Failed to start game: {message}',
      sessionExpired: 'Game session has expired. The game was saved automatically.',
      errorPrefix: '[Error: {message}]',
      sessionRestored: '--- Game session restored from memory ---\nType "look" to see where you are.',
      saved: 'Saved!',
      saveGame: 'Save game',
      restartTitle: 'Start over (deletes save)',
      closeAndSave: 'Close and save (ESC)',
      startNew: 'Start new game',
      thinking: 'Thinking...',
      wait: 'Please wait...',
      commandPlaceholder: 'Type a command...',
      turn: 'Turn: {count}',
      historySaved: 'History saved. The game continues automatically while the session is active (30 min).',
      loginToSave: 'Log in to save your game history.'
    },
    setupComponents: {
      cardDeck: 'Card deck',
      cube: 'Cube',
      disc: 'Disc',
      token: 'Token',
      resource: 'Resource',
      player: 'Player {number}',
      points: 'Points',
      diceCount: '{count} dice'
    }
  },
  sv: {
    common: {
      cancel: 'Avbryt',
      save: 'Spara',
      loading: 'Laddar...',
      required: 'Obligatoriskt',
      requiredField: 'Obligatoriskt fält',
      error: 'Fel',
      connectionError: 'Anslutningsfel. Försök igen.',
      saveFailed: 'Sparning misslyckades',
      saveError: 'Fel vid sparning',
      uploadFailed: 'Bilduppladdning misslyckades',
      select: 'Välj...',
      edit: 'Redigera',
      delete: 'Ta bort',
      add: 'Lägg till',
      close: 'Stäng',
      retry: 'Försök igen',
      rules: 'Regler',
      video: 'Video',
      players: 'spelare',
      player: 'Spelare',
      rank: 'Placering',
      points: 'Poäng',
      date: 'Datum',
      duration: 'Längd',
      results: 'Resultat',
      season: 'Säsong',
      games: 'spel',
      hours: 'h',
      minutes: 'min',
      hoursLabel: 'Timmar',
      minutesLabel: 'Minuter',
      noData: 'Ingen data',
      confirmDelete: 'Vill du verkligen ta bort?',
      optional: 'valfritt',
      allSeasonsHint: 'Tomt val = alla säsonger',
      allGamesHint: 'Tomt val = alla spel',
      clear: 'Rensa',
      noVotes: 'Inga röster',
      creating: 'Skapar...',
      upload: 'Ladda upp',
      url: 'URL',
      clickToOpen: 'Klicka för att öppna',
      leaguePoints: 'LP',
      victoryPoints: 'VP',
      victoryPointsTitle: 'Poäng i spelet',
      leaguePointsTitle: 'Ligapoäng (beräknas automatiskt)',
      leaguePointsRankTitle: 'Ligapoäng baserat på placering'
    },
    skillLevels: {
      beginner: 'Nybörjare',
      beginnerDesc: 'Första gången man spelar',
      novice: 'Novis',
      noviceDesc: 'Några spel bakom sig',
      hobbyist: 'Hobbyspelare',
      hobbyistDesc: 'Kan grundreglerna',
      experienced: 'Erfaren',
      experiencedDesc: 'Bekant med strategier',
      veteran: 'Veteran',
      veteranDesc: 'Avancerade taktiker',
      pro: 'Proffs',
      proDesc: 'Mästarnivå'
    },
    gameVariants: {
      standard: 'Grundspel',
      standardDesc: 'Officiella regler',
      quick: 'Snabbspel',
      quickDesc: 'Förkortad version',
      extended: 'Långt spel',
      extendedDesc: 'Utökade regler'
    },
    gamesLibrary: {
      title: 'Spelbibliotek',
      addGame: '+ Lägg till spel',
      prevGame: 'Föregående spel',
      nextGame: 'Nästa spel',
      downloadRules: 'Ladda ner regler (PDF)',
      watchVideo: 'Titta på instruktionsvideo',
      bggPage: 'BoardGameGeek-sida',
      gameSetup: 'Spelsetup',
      gameSetupTitle: 'Visa setup-guide',
      askHelp: 'Be om hjälp',
      askRulesTitle: 'Fråga om regler',
      history: 'Spelhistorik',
      noSessions: 'Inga spelade sessioner',
      seasonHeader: 'Säsong {season} ({count} spel)',
      setupFailed: 'Det gick inte att skapa setup-guiden',
      errorPrefix: 'Fel: {message}'
    },
    gameForm: {
      editTitle: 'Redigera spel',
      addTitle: 'Lägg till nytt spel',
      aiFound: '✨ AI hittade uppgifter!',
      aiFoundDesc: 'Fälten fylldes i automatiskt.',
      geminiInfo: 'Gemini AI-uppgifter:',
      nameLabel: 'Spelnamn *',
      namePlaceholder: 't.ex. Catan',
      aiHint: '🤖 AI hämtar automatiskt speluppgifter när du skriver namnet',
      bggIdLabel: 'BoardGameGeek-ID',
      bggIdPlaceholder: 't.ex. 13',
      bggIdHint: 'Finns i BGG-URL:en (boardgamegeek.com/boardgame/13/catan)',
      boxImage: 'Lådbild',
      setupImage: 'Setup-bild',
      imagesLabel: 'Spelbilder',
      boxImageHint: '📦 Lådbilden visas i spellistor och sökresultat',
      setupImageHint: '🎮 Setup-bilden visas som bakgrund i setup-instruktioner',
      imageUrlPlaceholder: 'https://... eller /game-images/...',
      saveImageToServer: 'Spara bild på servern',
      searchFor: 'Sök: "{query}"',
      clickToUpload: 'Klicka för att ladda upp',
      removeBoxImage: 'Ta bort lådbild',
      removeSetupImage: 'Ta bort setup-bild',
      bggLinkLabel: 'BGG-länk',
      bggLinkPlaceholder: 'https://boardgamegeek.com/...',
      bggLinkHint: 'Länk till BoardGameGeek-sidan',
      rulesPdfLabel: 'Regler (PDF)',
      rulesPdfPlaceholder: 'https://...rules.pdf',
      rulesPdfHint: 'Länk till PDF-regelbok',
      videoLabel: 'Instruktionsvideo',
      videoPlaceholder: 'https://youtube.com/watch?v=...',
      videoHint: 'YouTube-video för att lära sig spelet',
      expansions: 'Tillägg ({count})',
      confirmDeleteExpansion: 'Ta bort tillägget?',
      expansionName: 'Tilläggsnamn',
      expansionNamePlaceholder: 't.ex. Seafarers',
      owned: 'Vi äger',
      notOwned: 'Ägs inte',
      fetchingExpansions: 'Hämtar tillägg från BGG och AI...',
      foundExpansions: 'Hittade tillägg ({source})',
      noExpansionsFound: 'Inga tillägg hittades',
      iOwn: 'Jag äger',
      expansionNameRequired: 'Tilläggsnamn *'
    },
    sessionForm: {
      editTitle: 'Redigera session',
      addTitle: 'Registrera spel (session)',
      gameLabel: 'Spel',
      selectGame: 'Välj spel...',
      dateLabel: 'Datum',
      resultsLabel: 'Resultat',
      editResultsHint: 'Redigera placeringar och poäng. Ligapoäng beräknas automatiskt utifrån placering.',
      addResultsHint: 'Lägg till spelare i placeringsordning.',
      scorePlaceholder: 't.ex. 145',
      addPlayer: 'Lägg till spelare',
      expansionsUsed: 'Använda tillägg',
      loadingExpansions: 'Laddar tillägg...',
      expansionsHint: 'Välj tillägg som användes i sessionen',
      imageLabel: 'Bild (selfie / bräde)',
      changeImage: 'Byt bild',
      takeOrSelectImage: 'Ta en bild eller välj fil',
      saveChanges: 'Spara ändringar',
      saveSession: 'Spara session',
      uploadFailedContinue: 'Bilduppladdning misslyckades, sparar utan bild.'
    },
    setupDialog: {
      title: 'Spelsetup',
      unknownGame: 'Okänt spel',
      playerCount: 'Antal spelare',
      playerRange: '{game} stöder {min}-{max} spelare',
      skillLevel: 'Kompetensnivå',
      gameMode: 'Spelform',
      showSetup: 'Visa setup'
    },
    gameSetupOverlay: {
      setupTitle: 'Setup',
      gameBoard: '{name} spelbräde',
      generating: 'Genererar setup-guide...',
      analyzingRules: 'AI analyserar reglerna för "{name}"',
      errorTitle: 'Fel vid skapande av setup-guide',
      preparation: '📋 Förberedelse',
      turnStructure: '🔄 Turordning',
      selectTarget: 'Välj ett mål',
      noDescription: 'Ingen beskrivning tillgänglig.',
      steps: 'Steg:',
      clickHint: '👆 Klicka på ett markerat område för att se instruktioner',
      allParts: 'Alla delar:'
    },
    gameHelpChat: {
      title: 'Regelhjälp',
      gameFallback: 'Spel',
      rulesPdf: 'Regler (PDF)',
      assistant: 'Regelassistent',
      confidenceHigh: '✓ Säker',
      confidenceMedium: '~ Trolig',
      confidenceLow: '? Osäker',
      sources: '📚 Källor:',
      checkingRules: 'Kontrollerar reglerna...',
      quickQuestions: 'Snabbfrågor:',
      placeholder: 'Fråga om regler...',
      disclaimer: '⚠️ Svaren baseras på officiella regler. Kontrollera originalreglerna vid oklara situationer.',
      welcomeIntro: 'Välkommen till regelassistenten för {name}! 📖\n\nJag kan hjälpa till med spelregler. Jag svarar ENDAST enligt officiella regler — jag gissar eller tolkar inte.',
      welcomeExpansions: '\n\n📦 Tillägg ni äger: {list}\nJag kan också svara på frågor om dessa tillägg!',
      welcomeExamples: '\n\nProva att fråga:\n• "Hur går en tur till?"\n• "Vad händer vid lika?"\n• "Hur räknas poäng?"',
      noAnswer: 'Tyvärr kunde jag inte svara på frågan.',
      quickSetup: 'Hur förbereder man spelet?',
      quickTurn: 'Hur går en tur till?',
      quickEnd: 'Hur slutar spelet?',
      quickScoring: 'Hur räknas poäng?'
    },
    sessionDetail: {
      resultsTitle: 'Resultat'
    },
    eventScheduler: {
      title: 'Spelkvällar',
      loading: 'Laddar evenemang...',
      featureDisabled: 'Den här funktionen är inte aktiverad för den här klubben. En SuperAdmin kan aktivera den i klubbens betafunktioner.',
      suggestEvent: 'Föreslå spelkväll',
      noUpcoming: 'Inga kommande spelkvällar',
      suggestFirst: 'Föreslå den första!',
      attendees: '{count} deltagare',
      atTime: 'kl.',
      durationApprox: 'Längd: ~{hours} timmar',
      attendingQuestion: 'Deltar du?',
      attending: 'Deltar',
      maybe: 'Kanske',
      notAttending: 'Kan inte',
      registrations: 'Anmälningar',
      addPlayer: 'Lägg till',
      selectPlayer: 'Välj spelare...',
      attendingList: 'Deltar ({count})',
      maybeList: 'Kanske ({count})',
      declinedList: 'Kan inte ({count})',
      noRegistrations: 'Inga anmälningar ännu',
      markAttending: 'Markera som deltagande',
      deleteEvent: 'Ta bort spelkväll',
      confirmDeleteEvent: 'Vill du verkligen ta bort den här spelkvällen?',
      createTitle: 'Föreslå spelkväll',
      titleLabel: 'Titel *',
      titlePlaceholder: 't.ex. Torsdagsspel',
      scheduleLabel: 'Tid *',
      dateLabel: 'Datum',
      timeLabel: 'Klockslag',
      estimatedDuration: 'Beräknad längd',
      hour: '{n} timme',
      hours: '{n} timmar',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholder: 'Vad ska spelas? Något särskilt att tänka på?',
      gameOptional: 'Spel (valfritt)',
      selectLater: '-- Välj senare --',
      location: 'Plats',
      addNewLocation: 'Lägg till ny',
      locationName: 'Platsnamn *',
      locationNamePlaceholder: 't.ex. Matts hem',
      addressOptional: 'Adress (valfritt)',
      addressPlaceholder: 't.ex. Exempelgatan 1, Helsingfors',
      createLocation: 'Skapa plats',
      noLocationSelected: '-- Inte vald --',
      noSavedLocations: 'Inga sparade platser. Skapa en ny ovan.',
      suggestedLocation: '✨ Föreslagen utifrån föregående spelkväll',
      minPlayers: 'Min spelare',
      maxPlayers: 'Max spelare',
      visibilityHint: '📢 Alla klubbmedlemmar ser evenemanget och kan anmäla sig.',
      createEvent: 'Skapa spelkväll',
      titleRequired: 'Ange en titel för spelkvällen',
      dateTimeRequired: 'Datum och klockslag är obligatoriska',
      createFailed: 'Det gick inte att skapa evenemanget',
      locationCreateFailed: 'Det gick inte att skapa platsen'
    },
    suggestionBox: {
      title: '🗳️ Förslagslåda',
      subtitle: 'Dela idéer! Föreslå, rösta och kommentera.',
      privateMode: 'Privat läge: dina förslag syns bara för dig och admin.',
      tabOpen: 'Öppna',
      tabImplemented: 'Genomförda',
      tabRejected: 'Avvisade',
      statusOpen: 'Öppen',
      statusImplemented: 'Genomförd',
      statusRejected: 'Avvisad',
      suggestNew: 'Föreslå något nytt',
      newSuggestion: 'Nytt förslag',
      titleLabel: 'Titel *',
      titlePlaceholder: 'T.ex. Köp Catan',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholder: 'Berätta mer om idén...',
      submit: 'Skicka förslag',
      noSuggestions: 'Inga förslag ännu. Var först!',
      comments: 'Kommentarer ({count})',
      comment: 'Kommentera',
      markImplemented: 'Genomförd',
      markRejected: 'Avvisad',
      show: 'Visa',
      hide: 'Dölj',
      hiddenFromUsers: 'Dold för andra användare',
      commentsTitle: 'Kommentarer',
      noComments: 'Inga kommentarer ännu.',
      addComment: 'Lägg till kommentar...',
      confirmDelete: 'Vill du verkligen ta bort det här förslaget?'
    },
    statistics: {
      title: 'Spelstatistik',
      loading: 'Laddar statistik...',
      refreshing: 'Uppdaterar statistik...',
      errorPrefix: 'Fel: {message}',
      filterTitle: 'Filtrera analyser',
      seasons: 'Säsonger',
      games: 'Spel',
      proOnly: 'Pro',
      proRequired: 'Statistik för arkiverade säsonger kräver Pro.',
      currentSeasonOnly: 'Free-nivån omfattar den aktuella säsongen.',
      archivedProOnly: 'Arkiverade säsonger sparas och blir tillgängliga med Pro.',
      comparePlans: 'Jämför nivåer',
      totalSessions: 'Sessioner',
      uniqueGames: 'Olika spel',
      totalPlayers: 'Spelare',
      totalTime: 'Total tid',
      zeroMin: '0 min'
    },
    statisticsAnalytics: {
      loadingSessions: 'Laddar sessioner...',
      noSessionData: 'Ingen sessionsdata',
      clickGameHint: 'Klicka på ett spel för att se detaljer.',
      longestGames: 'Längsta spelen',
      longestGamesSub: 'Mest tid spenderad',
      mostPlayed: 'Mest spelade',
      mostPlayedSub: 'Mest frekvent spelade',
      winRates: 'Vinstprocent',
      winRatesSub: 'Minst 3 spel',
      winStreaks: 'Vinstsviter',
      winStreaksSub: 'Sammanhängande vinster',
      winStreakCount: '{count} vinster i rad',
      highestScores: 'Högsta poäng',
      highestScoresSub: 'Topp 10 prestationer',
      closestGames: 'Jämnaste spelen',
      closestGamesSub: 'Minsta marginal mellan vinnare och tvåa',
      playerFavorites: 'Spelarnas favoriter',
      playerFavoritesSub: 'Mest spelade spel per spelare',
      playedWins: 'Spelat {played}x • {wins} vinster',
      monthlyActivity: 'Månadsaktivitet',
      monthlyActivitySub: 'Speltrend',
      sessionsTooltip: '{count} sessioner',
      avgLeaguePoints: 'Genomsnittlig ligapoäng',
      avgLeaguePointsSub: 'Topplista per spelat spel',
      leaguePointsTitle: 'Ligapoäng',
      leaguePointsSub: 'Totalpoäng för valda säsonger och spel. Klicka på en spelare för att se spelen.',
      medalPercentage: 'Medaljplacering %',
      medalPercentageSub: 'Plats 1, 2 eller 3 i alla spel. Klicka på en spelare för att se medaljspelen.',
      medalTable: 'Medaljtabell',
      medalTableSub: 'Olympisk ordning: guld, silver, brons. Klicka på en spelare för att se medaljspelen.',
      headToHead: 'Inbördes möten',
      headToHeadSub: 'Vem slår vem oftast',
      colGame: 'Spel',
      colTotal: 'Totalt',
      colCount: 'Gånger',
      colAverage: 'Genomsnitt',
      colPlayed: 'Spelat',
      colPlayers: 'Spelare',
      colWinPct: 'Vinst-%',
      colWins: 'Vinster',
      colGames: 'Spel',
      colAvgRank: 'Snittpl.',
      colScore: 'Poäng',
      colDate: 'Datum',
      colMedalPct: 'Medalj-%',
      colMedals: 'Medaljer',
      colTotalShort: 'Tot.',
      vs: 'mot',
      socialNemesis: 'Nemesis',
      socialNemesisSub: 'Vem slutar oftare över dig (≥3 möten). Klicka på en spelare för att se sessionerna.',
      socialKingmaker: 'Kingmaker',
      socialKingmakerSub: 'Andraplatser i jämna spel (raw_score, ≥5 sessioner)',
      socialCloser: 'Closer',
      socialCloserSub: 'Vinstprocent i jämna spel (raw_score)',
      socialChoker: 'Choker',
      socialChokerSub: 'Jämna nära vinster bland topp-3',
      socialGiantSlayer: 'Giant Slayer',
      socialGiantSlayerSub: 'Vinster i sessioner med #1 (framgångspoäng)',
      socialSpecialist: 'Specialist',
      socialSpecialistSub: 'Spelet med högst vinstprocent (≥3 sessioner)',
      socialRivalry: 'Rivalry',
      socialRivalrySub: 'Mötesintensitet (≥3 gemensamma sessioner)',
      socialSkill: 'Skill-rating',
      socialSkillSub: 'OpenSkill-tal (ersätter inte framgångspoäng)',
      socialEvidenceGames: 'Spel som använts i beräkningen'
    },
    chatInterface: {
      fabTitle: 'The Oracle - AI Assistant',
      title: 'The Oracle',
      shrink: 'Minimera',
      fullscreen: 'Helskärm',
      oracle: 'oracle',
      cached: '⚡ cached',
      chartTitle: 'Statistik',
      autoRetry: 'Försöker igen automatiskt om:',
      analyzing: 'Analyserar...',
      placeholder: 'Fråga Oraklet...',
      connectionError: 'Anslutningsfel till Oraklet. Försök igen. 🌩️',
      welcome: 'Välkommen till Oraklet! 🔮\n\nDu kan fråga mig om:\n• Klubbstatistik\n• Spelregler\n• Vem är bästa spelaren?\n\nSkriv din fråga nedan...',
      chartValue: 'Värde'
    },
    nextGamePrediction: {
      analyzing: 'Analyserar sannolikhetsmatris...',
      predicted: '🔮 Kommande speldag: {count} spel förutspådda',
      askOracle: '🔮 Fråga Oraklet om kommande speldag',
      newPrediction: 'Ny förutsägelse',
      failed: 'Förutsägelsen misslyckades',
      title: 'Oraklets förutsägelse',
      upcomingGameDay: 'Kommande speldag',
      rationale: '💭 Motivering:',
      poweredByGemini: 'Gemini AI',
      poweredBySkill: 'Skill rating'
    },
    sessionWrap: {
      title: 'Sessionssammanfattning',
      winner: 'Vinnare',
      photoFinish: 'Photo finish (jämn raw_score)',
      copy: 'Kopiera text',
      copied: 'Kopierat'
    },
    smartRecommendations: {
      recommendation: 'Rekommendation',
      forYou: 'Rekommendationer för dig',
      view: 'Visa',
      gameSpecific: '🎯 För det här spelet',
      categoryMatch: '📂 Din stil',
      recentlyViewed: '👁️ Nyligen visat',
      featured: '⭐ Rekommenderat',
      aiSuggestion: '🤖 AI-rekommendation',
      default: '💡 Rekommendation'
    },
    terminalGame: {
      startFailed: 'Det gick inte att starta spelet: {message}',
      sessionExpired: 'Spelsessionen har gått ut. Spelet sparades automatiskt.',
      errorPrefix: '[Fel: {message}]',
      sessionRestored: '--- Spelsession återställd från minnet ---\nSkriv "look" för att se var du är.',
      saved: 'Sparat!',
      saveGame: 'Spara spel',
      restartTitle: 'Börja om (tar bort sparning)',
      closeAndSave: 'Stäng och spara (ESC)',
      startNew: 'Starta nytt spel',
      thinking: 'Thinking...',
      wait: 'Vänta...',
      commandPlaceholder: 'Skriv ett kommando...',
      turn: 'Tur: {count}',
      historySaved: 'Historik sparad. Spelet fortsätter automatiskt så länge sessionen är aktiv (30 min).',
      loginToSave: 'Logga in för att spara spelhistoriken.'
    },
    setupComponents: {
      cardDeck: 'Kortlek',
      cube: 'Kub',
      disc: 'Skiva',
      token: 'Token',
      resource: 'Resurs',
      player: 'Spelare {number}',
      points: 'Poäng',
      diceCount: '{count} tärningar'
    }
  }
};

/** Replace {key} placeholders in translation strings */
export function formatMemberText(template, vars = {}) {
  if (!template) return '';
  return String(template).replace(/\{(\w+)\}/g, (_, key) => (vars[key] != null ? vars[key] : `{${key}}`));
}

export default memberTranslations;
